import { ReactNode } from 'react';
import styled from 'styled-components';

import { SBHorizontal } from 'atoms/layout/flex';

const Wrapper = styled.div`
  padding: var(--double-unit);
  display: flex;
  flex-direction: column;
  gap: var(--double-unit);
  background-color: var(--c-neutral-200);
  ${props =>
    props.theme.hoverable
      ? `&:hover {
      background-color: var(--c-neutral-300);
    }`
      : ''}
`;

type Props = {
  StatusRow: ReactNode;
  FirstTeamRow: ReactNode;
  SecondTeamRow: ReactNode;
  hoverable?: boolean;
  className?: string;
};

export const Game = ({
  StatusRow,
  FirstTeamRow,
  SecondTeamRow,
  hoverable = false,
  className,
}: Props) => {
  return (
    <Wrapper theme={{ hoverable }} className={className}>
      <SBHorizontal gap={0}>{StatusRow}</SBHorizontal>
      <SBHorizontal gap={0}>{FirstTeamRow}</SBHorizontal>
      <SBHorizontal gap={0}>{SecondTeamRow}</SBHorizontal>
    </Wrapper>
  );
};
